var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFileDotted = function SvgIconFileDotted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.25 2a1 1 0 1 0 0 2h1.625v4.625a1 1 0 0 0 1 1H18.5v3.125a1 1 0 1 0 2 0v-4.5a1 1 0 0 0-.293-.707l-5.25-5.25A1 1 0 0 0 14.25 2zm6.21 5.625-2.585-2.586v2.586z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16.25a1 1 0 0 1 1 1V20h1.25a1 1 0 1 1 0 2h-1.5a1.75 1.75 0 0 1-1.75-1.75v-3a1 1 0 0 1 1-1M5.5 4h2a1 1 0 0 0 0-2H5.25A1.75 1.75 0 0 0 3.5 3.75V6a1 1 0 0 0 2 0zM20.5 20.25V16.5a1 1 0 1 0-2 0V20H18a1 1 0 1 0 0 2h.75a1.75 1.75 0 0 0 1.75-1.75M4.5 8.75a1 1 0 0 1 1 1v3.75a1 1 0 1 1-2 0V9.75a1 1 0 0 1 1-1M10.5 20a1 1 0 1 0 0 2h3.75a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconFileDotted;